<template>
  <footer class="footer">
    <div class="container">
      <div class="row full-width">
        <div class="col-xx-lg-2 col-x-lg-2 col-lg-3 col-xs-12">
          <router-link to="/" class="footer__logo">
            <img src="~@/assets/img/footer-logo.png" alt/>
          </router-link>
          <div class="footer__copyright" v-if="!getResponsive">
            ©ASTRAZENECA {{ year }}
          </div>
        </div>
        <div class="col-xx-lg-6 col-x-lg-7 col-lg-9 col-xs-12">
          <div class="footer__info">
            Лікарські засоби мають протипоказання та можливі побічні реакції. Лікарські засоби слід застосовувати тільки
            за призначенням та після консультації лікаря. UA-8063. Approved June 2026
          </div>
          <nav class="footer__nav">
            <a
                href="https://www.astrazeneca.ua/legal-information.html"
            >правові положення та умови використання</a>
            <a target="_blank" href="https://www.azprivacy.astrazeneca.com/ua/uk/privacy-notices/"
            >Політика конфіденційності</a
            >
            <a href="/Pharmacy_Instruction.pdf" target="_blank">ПІДКЛЮЧЕННЯ АПТЕК ДО ПРОГРАМИ</a>

            <router-link to="/terms-and-conditions"
            >Правила участі у програмі
            </router-link
            >
            <router-link to="/policy"
            >Політика конфіденційності Програми
            </router-link>

          </nav>
        </div>
        <div
            class="col-xx-lg-4 col-xx-lg-offset-0 col-x-lg-3 col-x-lg-offset-0 col-lg-9 col-lg-offset-3 col-xs-12"
        >
          <div class="footer__options">
            <div class="footer__copyright" v-if="getResponsive">
              ©ASTRAZENECA {{ year }}
            </div>
            <router-link
                to="/adverse-reaction"
                class="footer__btn"
                v-if="!getResponsive"
                @click.native="adverseReactionClick()"
            >Повідомити про побічну реакцію
            </router-link
            >
            <div class="footer__designed-by">
              <p>designed by</p>

              <a href="https://www.inchkiev.ua" target="_blank">
                <svg class="footer__designed-svg"  viewBox="0 0 135 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_44_230)">
                    <mask id="mask0_44_230" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0"
                          width="135" height="24">
                      <path d="M135 0H0V24H135V0Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_44_230)">
                      <path d="M0 1.56494H3.35996V21.6202H0V1.56494Z" fill="#0A152B"/>
                      <path
                          d="M21.1637 15.319V1.56494H24.4944V21.6202H22.3691L10.8827 7.88556V21.6202H7.52271V1.56494H9.94108L21.1637 15.319Z"
                          fill="#0A152B"/>
                      <path
                          d="M50.413 10.1893H60.0045V1.56494H63.3352V21.6202H60.0045V12.9393H50.413V21.6202H47.053V1.56494H50.413V10.1893Z"
                          fill="#0A152B"/>
                      <path
                          d="M122.519 0H82.9178C76.2752 0 70.8904 5.37259 70.8904 12C70.8904 18.6275 76.2752 24 82.9178 24H122.519C129.161 24 134.546 18.6275 134.546 12C134.546 5.37259 129.161 0 122.519 0Z"
                          fill="#A6C6DD"/>
                      <path
                          d="M124.937 8.63575C125.583 8.63575 126.158 8.77413 126.662 9.05089C127.176 9.32764 127.574 9.73694 127.861 10.2788C128.16 10.8225 128.308 11.4774 128.308 12.2453V17.2367H126.568V12.5065C126.568 11.7483 126.379 11.1695 126 10.7719C125.619 10.3626 125.101 10.1579 124.444 10.1579C123.788 10.1579 123.265 10.3626 122.874 10.7719C122.495 11.1714 122.304 11.7503 122.304 12.5065V17.2367H120.549V5.87012H122.304V9.75643C122.602 9.39781 122.976 9.12106 123.427 8.92811C123.89 8.7332 124.39 8.63575 124.935 8.63575H124.937Z"
                          fill="#0A152B"/>
                      <path
                          d="M116.562 10.203V14.8884C116.562 15.2061 116.633 15.436 116.777 15.5803C116.932 15.7128 117.187 15.7791 117.547 15.7791H118.625V17.2389H117.238C116.449 17.2389 115.842 17.0537 115.422 16.6854C115.002 16.3171 114.791 15.7187 114.791 14.8884V10.203H113.791V8.77435H114.791V6.66943H116.562V8.77435H118.625V10.203H116.562Z"
                          fill="#0A152B"/>
                      <path d="M111.901 5.87012V17.2367H110.147V5.87012H111.901Z" fill="#0A152B"/>
                      <path
                          d="M98.821 12.9664C98.821 12.1167 98.9948 11.3643 99.3426 10.7095C99.702 10.0546 100.185 9.54788 100.79 9.18925C101.405 8.82089 102.083 8.63574 102.824 8.63574C103.49 8.63574 104.07 8.76827 104.564 9.03529C105.066 9.29061 105.467 9.61414 105.764 10.002V8.77413H107.533V17.2367H105.764V15.9776C105.465 16.3772 105.06 16.7105 104.549 16.9755C104.037 17.2406 103.451 17.3751 102.792 17.3751C102.064 17.3751 101.396 17.1918 100.792 16.8216C100.186 16.4435 99.706 15.921 99.3445 15.2545C98.9968 14.5782 98.823 13.8162 98.823 12.9664H98.821ZM105.764 12.9976C105.764 12.4149 105.641 11.9062 105.394 11.4774C105.158 11.0467 104.844 10.7192 104.455 10.4951C104.064 10.269 103.644 10.1579 103.193 10.1579C102.742 10.1579 102.322 10.271 101.931 10.4951C101.54 10.7095 101.224 11.033 100.976 11.4618C100.739 11.8808 100.62 12.3837 100.62 12.9664C100.62 13.5492 100.739 14.0618 100.976 14.5022C101.222 14.9427 101.54 15.2798 101.931 15.5158C102.331 15.7419 102.751 15.853 103.193 15.853C103.634 15.853 104.064 15.7399 104.455 15.5158C104.845 15.2896 105.158 14.9622 105.394 14.5334C105.641 14.093 105.764 13.5804 105.764 12.9976Z"
                          fill="#0A152B"/>
                      <path
                          d="M97.3695 12.7988C97.3695 13.1165 97.348 13.403 97.307 13.6583H90.8275C90.8782 14.3346 91.1282 14.8764 91.5815 15.2857C92.0328 15.695 92.5875 15.8997 93.2439 15.8997C94.1873 15.8997 94.8555 15.5059 95.2442 14.7166H97.1371C96.8813 15.4943 96.4144 16.1355 95.7365 16.6363C95.0703 17.1275 94.2382 17.3731 93.2439 17.3731C92.4332 17.3731 91.7045 17.1938 91.058 16.8351C90.4231 16.4668 89.9191 15.9542 89.5518 15.2994C89.1923 14.6348 89.0127 13.8649 89.0127 12.9957C89.0127 12.1264 89.1866 11.3624 89.5362 10.7075C89.8937 10.0429 90.3918 9.53033 91.0286 9.17172C91.6753 8.81309 92.4137 8.63379 93.2458 8.63379C94.0781 8.63379 94.7597 8.80725 95.3867 9.15613C96.012 9.50499 96.5004 9.99614 96.848 10.6315C97.1978 11.2552 97.3715 11.9783 97.3715 12.7969L97.3695 12.7988ZM95.5392 12.2453C95.5295 11.6002 95.297 11.0837 94.8457 10.6939C94.3964 10.3041 93.8358 10.1111 93.1697 10.1111C92.562 10.1111 92.0464 10.306 91.6146 10.6939C91.183 11.072 90.9271 11.5904 90.8431 12.2453H95.5392Z"
                          fill="#0A152B"/>
                      <path
                          d="M86.9773 6.56201V17.2366H85.2231V12.5669H80.1891V17.2366H78.4348V6.56201H80.1891V11.1383H85.2231V6.56201H86.9773Z"
                          fill="#0A152B"/>
                      <path
                          d="M42.98 16.5026C42.0033 17.4672 40.4327 18.5509 38.9305 18.7927C38.5085 18.8627 38.071 18.8998 37.6177 18.8998C37.608 18.8998 37.5982 18.8998 37.5905 18.8998C37.5806 18.8998 37.571 18.8998 37.5631 18.8998C37.108 18.8998 36.6703 18.8607 36.2503 18.7927C36.1156 18.7712 35.9867 18.7419 35.8558 18.7146C32.6657 18.0072 30.5853 15.2941 30.5853 11.5949C30.5853 8.32646 32.2086 5.82785 34.7853 4.80073C35.6194 4.46744 36.5512 4.29008 37.5631 4.29008C37.5729 4.29008 37.5826 4.29008 37.5905 4.29008C37.6002 4.29008 37.61 4.29008 37.6177 4.29008C39.7862 4.29008 41.5032 5.13399 43.0074 6.63279L44.9062 4.2511C42.9722 2.36447 40.5343 1.35878 37.5905 1.31396C37.524 1.31396 37.4576 1.31006 37.3892 1.31006C31.2729 1.31006 27.1082 5.46533 27.1082 11.5949C27.1082 17.7246 31.2729 21.8798 37.3892 21.8798C37.4576 21.8798 37.5221 21.876 37.5905 21.876C40.5343 21.8312 43.0406 20.9755 45.1933 18.623L42.982 16.5045L42.98 16.5026Z"
                          fill="#0A152B"/>
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_44_230">
                      <rect width="135" height="24" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="popup-wrapper" v-if="popup">
      <div class="popup">
        <p>Документ в стадії розробки</p>
        <div class="btn-footer" @click="popup = false">Добре</div>
      </div>
    </div>
  </footer>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "Footer",
  computed: {
    ...mapGetters(["getResponsive"])
  },
  data() {
    return {
      popup: false,
      year: new Date().getFullYear()
    };
  },

  methods: {
    adverseReactionClick() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", {event_category: "click_button_side_reaction"}); //[Кнопка "Повідомити про побічну реакцію"(футер)]
    }
  }
};
</script>

<style lang="scss" scoped>
.popup-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;

  width: 100%;
  height: 100%;
  background: rgba(105, 182, 199, 0.9);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;

  .popup {
    background: white;
    padding: 20px 40px;
    border: 1px solid #3c1053;


    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      font-size: 22px;

      font-weight: 400;
      margin-bottom: 20px;
      color: rgb(60, 16, 83);
      text-align: center;
    }
  }

  .btn-footer {
    display: inline-flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.07em;
    text-transform: uppercase;

    background: #FFD770;
    border: 1px solid #F0AB00;
    border-radius: 2px;

    color: #3C1053;
    font-size: 12px;
    line-height: 19px;
    font-weight: 700;
    padding: 16px 24px;
    cursor: pointer;

    &:hover {
      background: #f0ab00;
      border: 1px solid #3c1053;
      color: #3c1053;
    }
  }
}



</style>
